import { Spin } from 'antd';
import LightbulbIcon from '../../assets/images/Lightbulb.svg';

export default function SettingsNotification({ text, withIcon, onClickFunction, maxWidth, isLoading }: { withIcon?: boolean, text: React.ReactNode, onClickFunction?: (event: React.MouseEvent<HTMLButtonElement>) => void, maxWidth: string, isLoading?: boolean }) {

    return (
        <>
            <div className={`relative ${maxWidth}`}>
                <div className="bg-yellow-50 py-2 px-2.5 rounded-md shadow-lg">
                    <div className="flex flex-col items-center">
                        {withIcon &&
                            <div className="mb-2">
                                <img src={LightbulbIcon} alt="Lightbulb" className="w-6 h-6 text-yellow-500" />
                            </div>}
                        <div className="text-center">
                            <p className="mb-1 text-sm text-yellow-800">
                                {text}
                            </p>
                            <span onClick={onClickFunction} className="p-0 m-0 text-xs font-bold text-yellow-800 underline cursor-pointer font-weight-700 hover:text-yellow-800">{isLoading ? <Spin size='small' /> : 'Dismiss'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

